module.exports = __webpack_public_path__ + "img/strike-yellow.cb4844fe.svg";